<template>
  <div class="canvasContainer" ref="canvasContainer">

    <v-stage ref="stage" class="relative"
      :config="configKonva"
      @wheel="handleWheel"
      @contextmenu="handleContextMenu"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
      @mousemove="handleMouseOver"
      @click="handleClick"

      >

      <v-layer ref="refBlocks" :config="{ id: 'layerBg', name: 'layerBg', visible: showAreas }" :listening="false">
        <v-line v-for="block in blocks" :key="'block_' + block.id"
          :config="block"></v-line>

        <v-text v-for="txt in txtBlocks" :key="'txt_' + txt.id" :listening="false"
          :config="txt"></v-text>
      </v-layer>

      <v-layer ref="layer" :config="{ id: 'layerEntities', name: 'layerEntities' }">
        <!-- Los grupos y entidades se crean directamente con Konva API para mejor rendimiento -->
      </v-layer>

      <v-layer ref="refVectors" :config="{ id: 'layerVectors', name: 'layerVectors' }">
      </v-layer>

    </v-stage>
  </div>
</template>

<script>
import axios from "axios"
import Vue from 'vue';
import Konva from 'konva';
import VueKonva from 'vue-konva';
import {KonvaViewer} from '../viewer-konva/utils/index'

import Uppy from '@uppy/core'
// import AwsS3Multipart from '@uppy/aws-s3-multipart'
import AwsS3 from '@uppy/aws-s3';
import store from "~/store";


Vue.use(VueKonva);

// Máximo de descargas de pictogramas EN PARALELO al cargar el parque. El navegador
// limita ~6 conexiones por dominio y el backend genera ~2MB por request, así que 6
// es el punto dulce (rápido sin saturar). El pool respeta este límite sea cual sea
// el número de pictogramas (5, 13, 50...).
const LOAD_CONCURRENCY = 6;

// Opacidad del relleno de las estructuras CON estado en el parque solar. El
// KonvaViewer (compartido) las pinta a 0.7 (translúcidas → color lavado); aquí
// las subimos para que el color de estado RESALTE más. Solo afecta a este visor.
// Subir a 1 para color 100% sólido; bajar hacia 0.7 para más transparencia.
const SOLAR_FILL_OPACITY = 1;

// Cómo se pintan los elementos SIN estado en el parque. Flag en código (no env)
// para comparar al vuelo y quedarnos con el que mejor se vea:
//   'fill'    → relleno gris plomo macizo (opción B).
//   'outline' → contorno gris plomo, cuerpo vacío (opción A, paridad con el visor de pictograma).
const NO_STATUS_RENDER_MODE = 'outline';

// Gris plomo, mismo tono que la línea gris del visor de pictograma (NO_STATUS_LINE_COLOR).
// En cuanto el elemento toma estado pasa a su color; así se ve lo que aún no tiene avance.
const NO_STATUS_FILL_COLOR = '#e0e0e0';
const NO_STATUS_OUTLINE_ALPHA = 0.8;  // alpha del contorno en modo 'outline'
const NO_STATUS_OUTLINE_PX = 1;       // grosor objetivo del contorno en px (constante al zoom)

export default {
    name: "ViewerDesign",

    components: {
    },

    props: {
      pictograms: { type: Array, default() { return [] } },
      entityId: { type: Number, required: true },
      entityType: { type: String, required: true},
      workLayer: { type: String, default: null },

      canActionsPictogram: { type: Object, default() { return {} } }, // acciones que se puede realizar sobre el pictograma por defecto ninguna
      showLayerCompleted: { type: Boolean, default: false }, // visualiza o oculta la capa de estructuras completadas
      designMode: { type: Boolean, default: false },
      pictogramType: { type: String, default: 'structures' }, // para identificar que tipo de pictogramas se debe visualizar
      isDrawing: { type: Boolean, default: false },
      selectedTool: { type: String, default: null },
      showAreas: { type: Boolean, default: false },
      drawingStrokeWidth: { type: Number, default: 0.3 },
      drawingDash: { type: Array, default() { return [] } }
    },

    data() {
      return {
        isLoading: false,
        progress: null,
        progressText: null,
        curProgressPhase: null,
        error: null,

        configKonva: {
          width: 800,
          height: 800,
          draggable: false,
          opacity: 1,
          pixelRatio: 2
        },


        filterStatuses: [], // estados filtrados segun se este visualizando estructuras hincados o modulos
        modifiedEntities: [], // lista de objetos que se modificaron y se mandaran para actualizar el general
        selectedObjects: [], // contiene los objetos seleccionados sobre los cuales se hande realizar acciones o acción

        powerPlant: { // objeto que hace contiene los datos del power plant
          id: 0,
          name: null
        },

        stage: null, // variable que contiene el stage/contenedor de grafica
        pics: [],
        scenes: {},

        selectedImage: null,
        selectedShapeName: '',
        keyFileUploadCurrent: null,
        selectedGroupId: null,
        hoveredGroupId: null,
        isDragging: false,
        _isPanMode: false,

        pointsShape: [], // almacena los puntos de la forma que se va a graficar
        drawingLine: null, // referencia a la linea Konva activa durante dibujo
        previewLine: null, // referencia a la linea de preview (mouse → ultimo punto)
        vertexCircles: [], // referencias a los circulos de vertices
        snapCircle: null, // circulo indicador de snap al punto inicial
        blockIdCounter: 0, // contador unico para IDs de bloques
        txtBlockIdCounter: 0, // contador unico para IDs de textos
        selectedBlockIndex: null, // indice del bloque seleccionado para edicion
        editVertexCircles: [], // circulos de vertices editables del bloque seleccionado
        selectedTxtIndex: null, // indice del texto seleccionado para mover
        editTxtNode: null, // nodo Konva.Text temporal draggable
        editTxtTransformer: null, // Transformer para rotar/redimensionar texto
        totalImageLoad: 0,
        savingData: false,
        allImagesUploaded: true,

        screenshots: [],

        blocks: [], // array de objetos de block vectors
        txtBlocks: [], // array de objetos de textos
      }
    },

    computed: {
    },

    watch: {
      async pictograms(newValue, oldvalue) {
        const delItem = []

        // Crear Set para búsqueda O(1) en lugar de O(n)
        const newValueIds = new Set(newValue.map(p => p.id))
        const existingSceneIds = new Set(Object.keys(this.scenes))

        // Buscamos pictogramas que ya no existen en el nuevo array
        for (const key of existingSceneIds) {
          if (!newValueIds.has(parseInt(key)) && !newValueIds.has(key)) {
            delItem.push(key)
          }
        }

        // Eliminamos los pictogramas
        delItem.forEach(id => {
          const node = this.stage.findOne('#GroupPictogram_' + id)
          if (node) {
            node.remove()
            this.$delete(this.scenes, id)

            const indexPic = this.pics.findIndex(p => p.id == id)
            if (indexPic > -1) {
              this.pics.splice(indexPic, 1)
            }
          }
        })

        if (delItem.length) {
          this.stage.batchDraw()
        }

        // Insertamos los que no están insertados
        for (const element of newValue) {
          if (!this.scenes[element.id]) {
            await this.LoadPictogramsJson(element)
          }
        }

        this._PrepareObjects()
        this.Render(this.pictogramType)
      },

      isDrawing(newValue) {
        if (!newValue) {
          // Al desactivar dibujo, limpiar estado y restaurar cursor
          this._ClearDrawing()
          this._DeselectBlock()
          this._DeselectTxt()
          this._SetCursor('default')
        } else {
          // Al activar dibujo, desactivar seleccion de grupos, bloques y textos
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
          this._SetCursor('crosshair')
        }
      },

      selectedTool(newValue) {
        if (newValue === 'pencil') {
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
          this._SetCursor('text')
        } else {
          this._SetCursor('default')
        }
      },

      selectedGroupId() {
        this._emitSelectedCount()
      },

      selectedBlockIndex() {
        this._emitSelectedCount()
      },

      selectedTxtIndex() {
        this._emitSelectedCount()
      },

      showAreas(newValue) {
        if (newValue) {
          // Al activar areas, desactivar seleccion/hover de grupos
          this._DeselectGroup()
          this.$refs.layer.getNode().batchDraw()
        } else {
          // Al desactivar areas, limpiar bloques y textos seleccionados
          this._DeselectBlock()
          this._DeselectTxt()
        }
      },

      async pictogramType(newValue, oldValue) {
        // Antes de cambiar de vista, guardar las posiciones actuales del canvas
        // en this.powerPlant.parts para no perderlas al renderizar otra vista
        this._SyncCurrentPositionsToMetadata(oldValue)

        this.$emit('epc-saving', { loading: true, text: this.$t('loading') + ' ' + this.$t(newValue) + '...' })

        // Permitir que el UI muestre el loader antes de renderizar
        await new Promise(resolve => setTimeout(resolve, 20))

        this.Render(newValue)
      },

      designMode(newValue, oldValue)  {
        // this._CacheGroups(newValue)
        if (!newValue) {
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
        }
      }
    },

    methods: {

      _ClearCache() {
        // Limpiar cache de todos los grupos de forma eficiente
        const layer = this.$refs.layer?.getNode()
        if (!layer) return

        layer.find('Group').forEach(group => {
          if (group.isCached()) {
            group.clearCache()
          }
        })
      },


      _ApplyCacheAsync() {
        // Aplicar cache de forma asíncrona para no bloquear el UI
        const layer = this.$refs.layer?.getNode()
        if (!layer) return

        const groups = layer.find('Group')
        let index = 0

        const cacheNextGroup = () => {
          if (index >= groups.length) {
            this.stage.batchDraw()
            return
          }

          const group = groups[index]
          if (group && !group.isCached()) {
            group.cache({ pixelRatio: 1 })
          }
          index++

          // Procesar el siguiente grupo en el próximo frame
          requestAnimationFrame(cacheNextGroup)
        }

        requestAnimationFrame(cacheNextGroup)
      },

      _CacheGroups(apply_cache) {
        if (!apply_cache) {
          this._ClearCache()
          return
        }

        // Solo aplicar cache si hay pocos grupos (evita congelar con muchos)
        if (this.pics.length <= 10) {
          this._ApplyCacheAsync()
        }
      },

      async Load() {
        this.isLoading = true
        this.$emit('epc-isloading', true)
        this.error = null

        let url = this.entityType == 'project'
          ? `/api/v2/project/${this.entityId}/power-plant`
          : `/api/v2/power-plant/${this.entityId}`;
        let params = {}
        let partsPark = []

        try {
          const response = await axios.get(url, { params: params })

          if (response.data && response.data.power_plant) {
            this.powerPlant = response.data.power_plant;

            response.data.power_plant.parts.forEach(part => {
              partsPark.push(part.pictogram_id)
            });

            if (response.data.power_plant.metadata != null) {
              response.data.power_plant.metadata.areas.texts.forEach(txt => {
                txt.draggable = true
                this.txtBlocks.push(txt);
              })

              response.data.power_plant.metadata.areas.blocks.forEach(block => {
                block.draggable = true
                this.blocks.push(block);
                if (block.id && block.id >= this._blockIdCounter) {
                  this._blockIdCounter = block.id
                }
              })
            }

            await this.LoadPictograms()
          }

          this.$emit('epc-loaded', partsPark);
        } catch (error) {
          console.warn(error);
        } finally {
          this.$emit('epc-isloading', false)
          this.isLoading = false
          this.progressText = null
          this.progress = null
          this.curProgressPhase = null
        }
      },

      async LoadPictograms() {
        // Descarga en PARALELO con concurrencia limitada (pool de workers sobre una
        // cola). El cuello era la descarga (~2.7s/pic × N en fila); solaparlas baja el
        // total a ≈ el más lento + cola. Funciona con cualquier N: siempre hay como
        // máximo LOAD_CONCURRENCY descargas en vuelo.
        await this._LoadPictogramsPool(this.powerPlant.parts)

        this._PrepareObjects()
        await this.Render(this.pictogramType)
      },

      /**
       * Pool de descarga con concurrencia limitada. Lanza N = LOAD_CONCURRENCY
       * "workers" que consumen una cola compartida de `parts`; en cada momento hay
       * como máximo N descargas en vuelo, sea cual sea el número de pictogramas.
       * La DESCARGA (lenta, es esperar al servidor) corre en paralelo; el PROCESO
       * que toca el konvaViewer compartido es SÍNCRONO dentro del worker (sin await
       * en medio), así no se pisan el estado entre pictogramas.
       */
      async _LoadPictogramsPool(parts) {
        this.isLoading = true
        this.$emit('epc-isloading', true)
        this.error = null

        const queue = (parts || []).slice()

        const worker = async () => {
          while (queue.length) {
            const part = queue.shift()
            if (!part || !part.pictogram) continue
            const pic = part.pictogram

            const design = await this._DownloadDesign(pic)  // paralelo: NO toca konvaViewer
            if (!design) continue

            // A partir de aquí SÍNCRONO → seguro con el konvaViewer compartido.
            this._ProcessPictogramScene(pic, design)
          }
        }

        const n = Math.min(LOAD_CONCURRENCY, queue.length)
        try {
          await Promise.all(Array.from({ length: n }, () => worker()))
        } finally {
          this.$emit('epc-isloading', false)
          this.isLoading = false
          this.progressText = null
          this.progress = null
          this.curProgressPhase = null
        }
      },

      /**
       * Descarga (solo red) el JSON del pictograma. NO toca el konvaViewer
       * compartido, por eso puede correr en paralelo. Devuelve el design parseado
       * o null si falla.
       */
      async _DownloadDesign(pic) {
        try {
          const { data: design } = await axios.get(`/api/v2/pictogram/${pic.id}/json`, { params: { compressed: 1 } })
          return design
        } catch (error) {
          console.warn('Error descargando pictograma ' + (pic && pic.id), error)
          this.error = error.toString()
          return null
        }
      },

      /**
       * Proceso SÍNCRONO: vuelca el design en el konvaViewer, lo transforma a
       * entidades y las guarda en scenes[pic.id] agrupadas por tipo. DEBE ser
       * síncrono (sin await) para no intercalarse con otro pictograma sobre el
       * konvaViewer compartido.
       */
      _ProcessPictogramScene(pic, design) {
        this.konvaViewer.SetDataPictogram(design)
        const scene = this.konvaViewer.GetEntities(pic.layers)

        // Pre-procesar entidades por tipo (O(n) una sola vez)
        const entitiesByType = {
          structures: [],
          pilings: [],
          modules: []
        }
        for (const entity of scene.entities) {
          if (entitiesByType[entity.type]) {
            entitiesByType[entity.type].push(entity)
          }
        }

        // Solo guardamos labels y entitiesByType, descartamos entities/backgrounds/completed
        // para liberar memoria (no se usan después del pre-filtrado)
        this.$set(this.scenes, pic.id, {
          labels: scene.labels,
          entitiesByType
        })

        // Liberar datos crudos del viewer que ya no se necesitan
        this.konvaViewer.entities = []
        this.konvaViewer.labels = []

        return scene
      },

      // Carga de UN pictograma individual (p. ej. al agregarse uno nuevo desde el
      // watcher `pictograms`). Reusa la descarga + proceso del pool.
      async LoadPictogramsJson(pic=null) {
        if (!pic) return

        this.isLoading = true
        this.$emit('epc-isloading', true)
        this.error = null

        try {
          const design = await this._DownloadDesign(pic)
          if (design) this._ProcessPictogramScene(pic, design)
        } catch (error) {
            console.warn(error)
            this.error = String(error)
        } finally {
            this.$emit('epc-isloading', false)
            this.isLoading = false
            this.progressText = null
            this.progress = null
            this.curProgressPhase = null
        }
      },

      _PrepareObjects() {
        Object.entries(this.scenes).forEach(([key, value]) => {
          if ( ! this.pics.find(p => p.id == key) ) {
            this.pics.push({
              id: key,
              config: {
                id: 'GroupPictogram_' + key,
                name: 'groupPictogram',
                draggable: false,
                x: 0,
                y: 0,
                rotation: 0
              },
              labels: value.labels,
              entities: []
            })
          }
        });
      },

      _GetMetadata(pictogram_id, type) {
        if ( ! this.powerPlant.parts )
          return  {
              x: 0,
              y: 0,
              rotation:0
            }

        let part = this.powerPlant.parts.find(x => x.pictogram_id == pictogram_id)

        if (part == null || part.metadata == null)
          return null

        if (part.metadata[type])
          return {
            x: part.metadata[type].x,
            y: part.metadata[type].y,
            rotation: part.metadata[type].rotation
          }

        if (part.metadata['default'])
          return {
              x: part.metadata['default'].x,
              y: part.metadata['default'].y,
              rotation: part.metadata['default'].rotation
            }
        else
          return {
            x: 0,
            y: 0,
            rotation:0
          }
      },

      _SyncCurrentPositionsToMetadata(type) {
        // Recorre los grupos del canvas y actualiza this.powerPlant.parts
        // con las posiciones actuales, para que al cambiar de vista no se pierdan
        const layer = this.$refs.layer?.getNode()
        if (!layer || !this.powerPlant.parts) return

        layer.find('Group').forEach(group => {
          const pictogramId = parseInt(group.id().replace('GroupPictogram_', ''))
          const part = this.powerPlant.parts.find(p => p.pictogram_id == pictogramId)
          if (!part) return

          if (!part.metadata) part.metadata = {}

          const pos = {
            x: group.x(),
            y: group.y(),
            rotation: group.rotation()
          }

          part.metadata[type] = pos
          part.metadata['default'] = { ...pos }
        })
      },

      _BuildPartsFromSaveData(dataPictograms) {
        // Construye o actualiza this.powerPlant.parts con los datos enviados al backend
        // Esto es necesario porque el backend no devuelve los parts en la respuesta
        if (!this.powerPlant.parts) {
          this.powerPlant.parts = []
        }

        for (const picData of dataPictograms) {
          const picId = parseInt(picData.id)
          let part = this.powerPlant.parts.find(p => p.pictogram_id == picId)

          if (part) {
            // Part existe: merge metadata (igual que hace el backend con array_merge)
            if (!part.metadata) part.metadata = {}
            Object.assign(part.metadata, picData.metadata)
          } else {
            // Part nuevo: crear entrada local
            this.powerPlant.parts.push({
              pictogram_id: picId,
              metadata: { ...picData.metadata }
            })
          }
        }
      },

      // Construye UNA sola Konva.Shape (sceneFunc) que pinta TODAS las entidades del
      // tipo activo de un pictograma, en vez de crear un Konva.Rect por entidad.
      // Los rects eran `listening:false` y la selección/hover trabaja a nivel de GRUPO
      // (via getClientRect), así que no se pierde interactividad. Esto colapsa decenas
      // de miles de nodos Konva a ~1 por pictograma → evita el freeze al cambiar a la
      // vista `modules` (la más densa: cada estructura tiene muchos paneles).
      _CreateEntitiesShape(entities) {
        if (!entities || entities.length === 0) return null

        // Bounding box en coords locales del grupo, para que el getClientRect del grupo
        // siga siendo correcto (selección, highlight, FitToScreen y Screenshot lo usan).
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
        for (const e of entities) {
          if (e.x < minX) minX = e.x
          if (e.y < minY) minY = e.y
          if (e.x + e.width > maxX) maxX = e.x + e.width
          if (e.y + e.height > maxY) maxY = e.y + e.height
        }
        if (!isFinite(minX)) return null

        // Agrupamos por color+opacidad para minimizar cambios de estado del canvas.
        // Con status=null casi todas comparten el color de la CAPA → un único bucket.
        // Las coords se desplazan al frame local de la shape (origen = minX,minY),
        // porque dentro del sceneFunc (0,0) es la posición de la shape.
        // Cada bucket agrupa por color+opacidad. `stroke:true` → se dibuja como
        // contorno (modo A, elementos sin estado); si no, relleno macizo.
        const buckets = new Map()
        for (const e of entities) {
          let fill, opacity, stroke = false
          if (e.status != null) {
            // Con estado: color de estado sólido (misma regla que antes: opacity 1).
            fill = e.fill
            opacity = SOLAR_FILL_OPACITY
          } else if (NO_STATUS_RENDER_MODE === 'outline') {
            // Modo A: contorno gris plomo, cuerpo vacío (paridad con el visor de pictograma).
            fill = NO_STATUS_FILL_COLOR
            opacity = NO_STATUS_OUTLINE_ALPHA
            stroke = true
          } else {
            // Modo B: relleno gris plomo macizo.
            fill = NO_STATUS_FILL_COLOR
            opacity = e.opacity != null ? e.opacity : 1
          }
          if (!fill) continue

          const key = fill + '|' + opacity + '|' + stroke
          let b = buckets.get(key)
          if (!b) { b = { fill, opacity, stroke, rects: [] }; buckets.set(key, b) }
          // Array plano [x,y,w,h,...] para recorrer rápido en el sceneFunc.
          b.rects.push(e.x - minX, e.y - minY, e.width, e.height)
        }

        const drawBuckets = Array.from(buckets.values())
        if (drawBuckets.length === 0) return null

        return new Konva.Shape({
          name: 'entitiesShape',
          x: minX,
          y: minY,
          width: maxX - minX,
          height: maxY - minY,
          listening: false,
          sceneFunc: (ctx, shape) => {
            // Grosor en coords locales que se ve ~constante en pantalla: dividimos
            // el objetivo en px por la escala absoluta (el zoom vive en el stage).
            const scale = shape.getAbsoluteScale().x || 1
            const lineWidth = NO_STATUS_OUTLINE_PX / scale
            for (const b of drawBuckets) {
              ctx.globalAlpha = b.opacity
              const r = b.rects
              if (b.stroke) {
                ctx.strokeStyle = b.fill
                ctx.lineWidth = lineWidth
                for (let i = 0; i < r.length; i += 4) {
                  ctx.strokeRect(r[i], r[i + 1], r[i + 2], r[i + 3])
                }
              } else {
                ctx.fillStyle = b.fill
                for (let i = 0; i < r.length; i += 4) {
                  ctx.fillRect(r[i], r[i + 1], r[i + 2], r[i + 3])
                }
              }
            }
            ctx.globalAlpha = 1
          }
        })
      },

      async Render(type) {
        const layer = this.$refs.layer.getNode()

        const existingGroupIds = new Set()

        // Recorrer grupos existentes para reutilizar o eliminar
        layer.find('Group').forEach(group => {
          existingGroupIds.add(group.id())
        })

        // Set de ids que deberían existir
        const expectedGroupIds = new Set(
          this.pics.filter(p => this.scenes[p.id]).map(p => 'GroupPictogram_' + p.id)
        )

        // Eliminar grupos que ya no deben estar
        layer.find('Group').forEach(group => {
          if (!expectedGroupIds.has(group.id())) {
            group.destroy()
          }
        })

        for (const pic of this.pics) {
          const sceneData = this.scenes[pic.id]
          if (!sceneData) continue

          const groupId = 'GroupPictogram_' + pic.id
          const metadata = this._GetMetadata(pic.id, type)
          let group = layer.findOne('#' + groupId)

          if (group) {
            // Grupo existe: actualizar posición y solo reemplazar entidades (Rect)
            group.setAttrs({
              draggable: this.designMode,
              x: metadata?.x || 0,
              y: metadata?.y || 0,
              rotation: metadata?.rotation || 0
            })

            // Eliminar la shape de entidades del tipo anterior, conservar los Text (labels)
            group.find('.entitiesShape').forEach(shape => shape.destroy())
          } else {
            // Grupo nuevo: crear con labels
            group = new Konva.Group({
              id: groupId,
              name: 'groupPictogram',
              draggable: this.designMode,
              x: metadata?.x || 0,
              y: metadata?.y || 0,
              rotation: metadata?.rotation || 0
            })

            if (sceneData.labels) {
              for (const labelConfig of sceneData.labels) {
                group.add(new Konva.Text(labelConfig))
              }
            }

            layer.add(group)
          }

          // Agregar las entidades del tipo actual como UNA sola shape con sceneFunc
          // (antes: un Konva.Rect por entidad → decenas de miles de nodos en `modules`
          // congelaban el hilo principal). Ver _CreateEntitiesShape.
          const entities = sceneData.entitiesByType?.[type] || []
          const entitiesShape = this._CreateEntitiesShape(entities)
          if (entitiesShape) group.add(entitiesShape)
        }

        // Renderizar una sola vez al final
        layer.batchDraw()

        // Centrar contenido
        await this.$nextTick()
        this.konvaViewer.FitToScreen()

        this.$emit('epc-saving', { loading: false, text: null })
      },

      GetLayers() {
        return this.konvaViewer.GetLayers()
      },

      EnableDraggable(enable) {
        this.konvaViewer.EnableDraggable(enable)
        this._SetCursor(enable ? 'grab' : 'default')
        this._isPanMode = enable
      },

      async SaveScreenshot(imgDataUrl) {
        try {
          this.$emit('epc-saving', { loading: true, text: 'Guardando captura' })
          await this.$nextTick()

          const baseName = this.pictogramType + (this.showAreas ? '_with_area' : '')
          const base64Data = imgDataUrl.replace('data:image/png;base64,', '')
          const pngBlob = this._Base64ToBlob(base64Data, 'image/png')
          const jpgBlob = await this._convertToJpg(imgDataUrl, 0.9)

          const screenshots = [
            { name: baseName + '.png', src: pngBlob },
            { name: baseName + '_a4.jpg', src: jpgBlob }
          ]

          this.$emit('epc-saving', { loading: true, text: 'Subiendo capturas' })

          const uploadResults = []
          for (const item of screenshots) {
            uploadResults.push(await this._submitResource(item))
          }

          const arrAwsResponse = uploadResults.filter(r => r !== null)
          if (arrAwsResponse.length !== screenshots.length) {
            this.$notify.error('error_saving')
            return false
          }

          this.$emit('epc-saving', { loading: true, text: 'Guardando datos' })

          const url = `/api/v2/power-plant/${this.powerPlant.id}`
          const form = new FormData()
          form.append('update_only_screenshot', 1)
          form.append('aws_images', JSON.stringify(arrAwsResponse))

          const response = await axios.post(url, form)
          if (response.data && response.data.success) {
            this.$notify.success('success_editing')
            return true
          } else {
            this.$notify.error('error_saving')
            return false
          }
        } catch (error) {
          console.error('Error en SaveScreenshot():', error)
          this.$notify.error('error_saving')
          return false
        } finally {
          this.$emit('epc-saving', { loading: false, text: null })
        }
      },

      async Save() {
        try {
          // Limpiar selección y hover antes de capturar screenshot
          // para que no se incluyan en la imagen ni queden en estado inconsistente
          this._DeselectGroup()
          this._DeselectBlock()
          this._DeselectTxt()
          this.$refs.layer.getNode().batchDraw()

          this.$emit('epc-saving', { loading: true, text: 'Generando captura de ' + this.$t(this.pictogramType) })
          await this.$nextTick();
          // Esperamos dos frames reales de pintura para que el browser renderice el loader
          // antes de ejecutar el toDataURL() síncrono que bloquea el hilo principal
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)))

          this.savingData = true

          let img = this.konvaViewer.Screenshot({ includeOverlays: this.showAreas })
          // CropImage: deshabilitado porque CalculateBoundingBox ya recorta al contenido con padding,
          // el escaneo pixel-por-pixel de CropImage es redundante y costoso en imágenes grandes
          // img = await this.konvaViewer.CropImage(img);
          img = await this.konvaViewer.GetBase64Image(img, true)

          const baseName = this.pictogramType + (this.showAreas ? '_with_area' : '')
          const base64Data = img.replace('data:image/png;base64,', '')
          const pngBlob = this._Base64ToBlob(base64Data, 'image/png')
          const jpgBlob = await this._convertToJpg(img, 0.9)

          const screenshots = [
            { name: baseName + '.png', src: pngBlob },
            { name: baseName + '_a4.jpg', src: jpgBlob }
          ]

          // Subir screenshots en paralelo
          this.$emit('epc-saving', { loading: true, text: 'Guardando capturas' })

          const uploadResults = []
          for (const item of screenshots) {
            uploadResults.push(await this._submitResource(item))
          }

          // Validar que todas las subidas fueron exitosas
          const arrAwsResponse = uploadResults.filter(r => r !== null)
          if (arrAwsResponse.length !== screenshots.length) {
            this.$notify.error('error_saving')
            return
          }

          // Guardar datos solo si los uploads fueron exitosos
          this.$emit('epc-saving', { loading: true, text: 'Guardando datos' })
          this._CacheGroups(true)

          await this._SaveDataPowerPlant(arrAwsResponse);

        } catch (error) {
          console.error('Error en Save():', error)
          this.$notify.error('error_saving')
        } finally {
          this.savingData = false
          this.$emit('epc-saving', { loading: false, text: null })
        }
      },

      _Base64ToBlob(base64String, contentType) {
        const byteCharacters = atob(base64String)
        const byteArray = new Uint8Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i)
        }
        return new Blob([byteArray], { type: contentType })
      },

      _convertToJpg(pngDataUrl, quality) {
        return new Promise((resolve) => {
          const image = new Image()
          image.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = image.width
            canvas.height = image.height
            const ctx = canvas.getContext('2d')
            // Fondo blanco para reemplazar transparencia PNG
            ctx.fillStyle = '#FFFFFF'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(image, 0, 0)
            canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality)
          }
          image.src = pngDataUrl
        })
      },

      async _submitResource(resource) {
        try {
          const blob = resource.src;
          const file = new File([blob], resource.name, { type: blob.type })
          const result = await this._store(file)

          if (result.successful.length > 0) {
            const response = result.successful[0].response
            return {
              key: response.body.key,
              name: resource.name,
              content_type: blob.type,
            }
          }

          if (result.failed.length > 0) {
            result.failed.forEach((f) => console.error('Upload failed:', f.error))
          }
          return null
        } catch (error) {
          console.error('Error uploading resource:', error)
          return null
        }
      },

      async _store(file) {
        // Limpiar archivo previo de Uppy antes de agregar uno nuevo
        if (this.keyFileUploadCurrent) {
          try { this.uppy.removeFile(this.keyFileUploadCurrent) } catch (e) { /* ya no existe */ }
          this.keyFileUploadCurrent = null
        }

        this.keyFileUploadCurrent = this.uppy.addFile({
          name: file.name,
          type: file.type,
          data: file,
          source: 'Local',
          isRemote: false,
        });

        return this.uppy.upload()
      },

      async _SaveDataPowerPlant(awsResponseImages) {
        // 1. contabilizar primero total de entidades por typo y estado
        let dataPictograms = []

        let stage = this.stage

        this.$refs.layer.getNode().find('Group').forEach(group => {

          let imgData = {
            id: group.id().replace('GroupPictogram_', ''),
            metadata: { }
          }

          if (this.pictogramType === 'structures') {
            imgData.metadata['default'] = {
              x: group.x(),
              y: group.y(),
              // width: node.width(),
              // height: node.height(),
              rotation: group.rotation()
            }
          }

          imgData.metadata[this.pictogramType] = {
            x: group.x(),
            y: group.y(),
            // width: node.width(),
            // height: node.height(),
            rotation: group.rotation()
          }

          dataPictograms.push(imgData)
        });

        // 3. preparar para mandar al backend
        let form = new FormData();

        form.append('name', 'power plant project ' + this.entityId)
        form.append('pictograms', JSON.stringify(dataPictograms))
        form.append('aws_images', JSON.stringify(awsResponseImages))

        let areas = { blocks: [], texts: [] }

        this.blocks.forEach(block => {
          areas.blocks.push({
            id: block.id,
            name: block.name,
            points: block.points,
            fill: block.fill,
            closed: block.closed,
            opacity: block.opacity,
            stroke: block.stroke,
            strokeWidth: block.strokeWidth,
            dash: block.dash,
            lineCap: block.lineCap,
            lineJoin: block.lineJoin,
            x: block.x,
            y: block.y
          })
        })

        this.txtBlocks.forEach(txt => {
          areas.texts.push({
            id: txt.id,
            name: txt.name,
            fontSize: txt.fontSize,
            fontStyle: txt.fontStyle,
            rotation: txt.rotation,
            width: txt.width,
            text: txt.text,
            x: txt.x,
            y: txt.y
          })
        })

        form.append('metadata', JSON.stringify({ areas: areas }))

        let url = `/api/v2/project/${this.entityId}/power-plant` // add url

        if (this.powerPlant.id) {
          url = `/api/v2/power-plant/${this.powerPlant.id}` // edit url
        }

        // Enviamos el form
        return await axios.post(url, form)
          .then((response) => {
            let data = response.data

            if (data && data.success) {
              // Si es la primera vez (create), el backend devuelve el id del power plant
              // para que las siguientes operaciones sean edits y no creen duplicados
              if (data.power_plant_id) {
                this.powerPlant.id = data.power_plant_id
              }

              // Construir/actualizar this.powerPlant.parts con las posiciones actuales
              // El backend no devuelve los parts en la respuesta, así que los mantenemos localmente
              this._BuildPartsFromSaveData(dataPictograms)
              this.$notify.success('success_editing')
              console.log('%cEPC-TACKER: '+ '%c power plant guardado correctamente.', 'background: #5577BB; color: #fff', 'color: #000')

              return true;
            } else if(data && data.msg){
              this.$notify.error('no_access_permissions')
            } else {
              this.$notify.error('error_saving')
            }

            return false;
          })
          .catch(error => {
            // Manejar errores aquí
            if (error.response) {
              // La solicitud fue hecha y el servidor respondió con un estado de error
              this.$notify.error(error.response.data.message)
              // console.log('Error de respuesta:', error.response.status, error.response.data);
              console.error('%cEPC-TACKER: '+ '%c Error de respuesta:', 'background: #5577BB; color: #fff', 'color: #000', error.response.status, error.response.data)
            } else if (error.request) {
              // La solicitud se realizó pero no se recibió respuesta del servidor
              this.$notify.error('No se recibió respuesta del servidor (E500)')
              console.error('%cEPC-TACKER: '+ '%c No se recibió respuesta del servidor', 'background: #5577BB; color: #fff', 'color: #000')
            } else {
              // Ocurrió un error antes de la solicitud, como una configuración incorrecta de Axios
              this.$notify.error('Error de configuración')
              console.error('%cEPC-TACKER: '+ '%c Error de configuración:', 'background: #5577BB; color: #fff', 'color: #000', error.message)
            }

            return false;
          })
      },

      _OnProgress(phase, size, totalSize) {
          if (phase !== this.curProgressPhase) {
              switch(phase) {
              case "font":
                  this.progressText = "Fetching fonts..."
                  break
              case "fetch":
                  this.progressText = "Fetching file..."
                  break
              case "parse":
                  this.progressText = "Parsing file..."
                  break
              case "prepare":
                  this.progressText = "Preparing rendering data..."
                  break
              }
              this.curProgressPhase = phase
          }
          if (totalSize === null) {
              this.progress = -1
          } else {
              this.progress = size / totalSize
          }
      },

      // ========== DIBUJO DE VECTORES ==========

      _GetMousePointTransformed() {
        const pos = this.stage.getPointerPosition()
        if (!pos) return null
        const transform = this.stage.getAbsoluteTransform().copy()
        transform.invert()
        return transform.point(pos)
      },

      _GetSnapDistance() {
        const zoomLevel = this.konvaViewer.GetZoomLavel() || 1
        return 10 / zoomLevel
      },

      _IsNearFirstPoint(point) {
        if (this.pointsShape.length < 3) return false
        const first = this.pointsShape[0]
        const dx = point.x - first.x
        const dy = point.y - first.y
        return Math.sqrt(dx * dx + dy * dy) < this._GetSnapDistance()
      },

      handleDrawingClick(e) {
        if (!this.isDrawing) return

        e.evt.preventDefault()
        const point = this._GetMousePointTransformed()
        if (!point) return

        const vectorLayer = this.$refs.refVectors.getNode()

        // Si esta cerca del primer punto y hay al menos 3 puntos, cerrar poligono
        if (this._IsNearFirstPoint(point)) {
          this._ClosePolygon()
          return
        }

        // Agregar punto
        this.pointsShape.push({ x: point.x, y: point.y })

        // Actualizar o crear la linea principal
        this._UpdateDrawingLine()

        // Agregar circulo de vertice
        this._AddVertexCircle(point)

        vectorLayer.batchDraw()
      },

      _UpdateDrawingLine() {
        const vectorLayer = this.$refs.refVectors.getNode()
        const flatPoints = this.pointsShape.flatMap(p => [p.x, p.y])

        if (!this.drawingLine) {
          const zoomLevel = this.konvaViewer.GetZoomLavel() || 1
          this.drawingLine = new Konva.Line({
            name: 'drawingLine',
            points: flatPoints,
            stroke: '#2980b9',
            strokeWidth: Math.max(0.3, 1 / zoomLevel),
            lineCap: 'round',
            lineJoin: 'round',
            listening: false,
          })
          vectorLayer.add(this.drawingLine)
          this.drawingLine.moveToBottom()
        } else {
          this.drawingLine.points(flatPoints)
        }
      },

      _AddVertexCircle(point) {
        const vectorLayer = this.$refs.refVectors.getNode()
        const isFirst = this.vertexCircles.length === 0
        const radius = this._GetVertexRadius()
        const strokeWidth = Math.max(0.5, 1.5 / (this.konvaViewer.GetZoomLavel() || 1))

        const circle = new Konva.Circle({
          name: isFirst ? 'vertexFirst' : 'vertex',
          x: point.x,
          y: point.y,
          radius: radius,
          fill: isFirst ? '#e74c3c' : 'white',
          stroke: isFirst ? '#c0392b' : '#2980b9',
          strokeWidth: strokeWidth,
          listening: false,
        })

        vectorLayer.add(circle)
        this.vertexCircles.push(circle)
      },

      handleDrawingMouseMove(e) {
        if (!this.isDrawing || this.pointsShape.length === 0) return

        const point = this._GetMousePointTransformed()
        if (!point) return

        const vectorLayer = this.$refs.refVectors.getNode()
        const lastPoint = this.pointsShape[this.pointsShape.length - 1]

        // Actualizar o crear linea de preview
        if (!this.previewLine) {
          const zoomLevel = this.konvaViewer.GetZoomLavel() || 1
          this.previewLine = new Konva.Line({
            name: 'previewLine',
            points: [lastPoint.x, lastPoint.y, point.x, point.y],
            stroke: '#2980b9',
            strokeWidth: Math.max(0.3, 0.8 / zoomLevel),
            dash: [6 / zoomLevel, 3 / zoomLevel],
            listening: false,
          })
          vectorLayer.add(this.previewLine)
        } else {
          this.previewLine.points([lastPoint.x, lastPoint.y, point.x, point.y])
        }

        // Indicador de snap: cambiar color del primer vertice si esta cerca
        const firstCircle = this.vertexCircles[0]
        if (firstCircle) {
          const isNear = this._IsNearFirstPoint(point)
          const radius = this._GetVertexRadius()
          firstCircle.fill(isNear ? '#2ecc71' : '#e74c3c')
          firstCircle.stroke(isNear ? '#27ae60' : '#c0392b')
          firstCircle.radius(isNear ? radius * 1.4 : radius)
        }

        vectorLayer.batchDraw()
      },

      _ClosePolygon() {
        this.blockIdCounter++
        const blockId = this.blockIdCounter
        const flatPoints = this.pointsShape.flatMap(p => [p.x, p.y])

        // Cerrar: agregar primer punto al final
        flatPoints.push(this.pointsShape[0].x, this.pointsShape[0].y)

        this.blocks.push({
          id: blockId,
          name: 'block_' + blockId,
          points: flatPoints,
          fill: 'rgba(236, 236, 236, 0.68)',
          closed: true,
          stroke: 'black',
          strokeWidth: this.drawingStrokeWidth,
          dash: this.drawingDash.length > 0 ? [...this.drawingDash] : undefined,
          lineCap: 'round',
          lineJoin: 'round',
          opacity: 0.7
        })

        // Limpiar estado de dibujo
        this._ClearDrawing()
        this.$emit('epc-viewer-design-mode-drawing', false)
      },

      _UndoLastPoint() {
        if (this.pointsShape.length === 0) return

        const vectorLayer = this.$refs.refVectors.getNode()

        // Eliminar ultimo punto
        this.pointsShape.pop()

        // Eliminar ultimo circulo de vertice
        const lastCircle = this.vertexCircles.pop()
        if (lastCircle) lastCircle.destroy()

        if (this.pointsShape.length === 0) {
          // No quedan puntos, limpiar todo
          this._ClearDrawing()
        } else {
          // Actualizar la linea con los puntos restantes
          this._UpdateDrawingLine()
        }

        vectorLayer.batchDraw()
      },

      _CancelDrawing() {
        this._ClearDrawing()
        this.$emit('epc-viewer-design-mode-drawing', false)
      },

      _ClearDrawing() {
        const vectorLayer = this.$refs.refVectors?.getNode()
        if (vectorLayer) {
          vectorLayer.destroyChildren()
        }

        this.pointsShape = []
        this.drawingLine = null
        this.previewLine = null
        this.vertexCircles = []

        if (vectorLayer) {
          vectorLayer.batchDraw()
        }
      },

      handleDrawingKeyDown(e) {
        if (!this.isDrawing) return

        // Escape: cancelar dibujo completo
        if (e.key === 'Escape') {
          e.preventDefault()
          this._CancelDrawing()
          return
        }

        // Ctrl+Z: deshacer ultimo punto
        if (e.key === 'z' && (e.ctrlKey || e.metaKey)) {
          e.preventDefault()
          this._UndoLastPoint()
          return
        }
      },

      // ========== EDICION DE VERTICES DE BLOQUES ==========

      _GetVertexRadius() {
        const zoomLevel = this.konvaViewer.GetZoomLavel() || 1
        return 5 / zoomLevel
      },

      _SelectBlock(blockIndex) {
        // Deseleccionar bloque/texto anterior si hay uno
        this._DeselectBlock()
        this._DeselectTxt()

        this.selectedBlockIndex = blockIndex
        const block = this.blocks[blockIndex]
        if (!block || !block.points || block.points.length < 6) return

        // Resaltar el bloque seleccionado
        this._originalBlockStroke = block.stroke
        this._originalBlockFill = block.fill
        this.$set(this.blocks[blockIndex], 'stroke', '#2980b9')
        this.$set(this.blocks[blockIndex], 'fill', 'rgba(52, 152, 219, 0.15)')

        this.$emit('epc-block-editing', {
          strokeWidth: block.strokeWidth,
          dash: block.dash || [],
          hasFill: block.fill && block.fill !== 'transparent'
        })

        const vectorLayer = this.$refs.refVectors.getNode()
        const points = block.points
        const radius = this._GetVertexRadius()
        const strokeWidth = Math.max(0.5, 1.5 / (this.konvaViewer.GetZoomLavel() || 1))

        // Crear circulos editables en cada vertice (los puntos van en pares x,y)
        // El ultimo par es igual al primero (cierre), lo omitimos
        const numVertices = (points.length / 2) - 1
        for (let i = 0; i < numVertices; i++) {
          const x = points[i * 2]
          const y = points[i * 2 + 1]

          const circle = new Konva.Circle({
            name: 'editVertex',
            x: x,
            y: y,
            radius: radius,
            fill: 'white',
            stroke: '#2980b9',
            strokeWidth: strokeWidth,
            draggable: true,
            hitStrokeWidth: radius * 2,
          })

          const vertexIndex = i
          circle.on('dragmove', () => {
            this._OnVertexDrag(vertexIndex, circle)
          })

          circle.on('mouseover', () => {
            circle.fill('#2980b9')
            circle.radius(radius * 1.2)
            this._SetCursor('move')
            vectorLayer.batchDraw()
          })

          circle.on('mouseout', () => {
            circle.fill('white')
            circle.radius(radius)
            this._SetCursor('default')
            vectorLayer.batchDraw()
          })

          vectorLayer.add(circle)
          this.editVertexCircles.push(circle)
        }

        vectorLayer.batchDraw()
      },

      DeleteSelectedBlock() {
        if (this.selectedBlockIndex === null) return
        const idx = this.selectedBlockIndex
        this._DeselectBlock()
        this.blocks.splice(idx, 1)
      },

      DeleteSelectedTxt() {
        if (this.selectedTxtIndex === null) return
        const idx = this.selectedTxtIndex
        this._DeselectTxt()
        this.txtBlocks.splice(idx, 1)
      },

      UpdateSelectedBlockStrokeWidth(width) {
        if (this.selectedBlockIndex === null) return
        this.$set(this.blocks[this.selectedBlockIndex], 'strokeWidth', width)
      },

      UpdateSelectedBlockDash(dash) {
        if (this.selectedBlockIndex === null) return
        this.$set(this.blocks[this.selectedBlockIndex], 'dash', dash.length > 0 ? dash : undefined)
      },

      UpdateSelectedBlockFill(filled) {
        if (this.selectedBlockIndex === null) return
        const fill = filled ? 'rgba(236, 236, 236, 0.68)' : 'transparent'
        this._originalBlockFill = fill
        this.$set(this.blocks[this.selectedBlockIndex], 'fill', filled ? 'rgba(52, 152, 219, 0.15)' : 'transparent')
      },

      _OnVertexDrag(vertexIndex, circle) {
        if (this.selectedBlockIndex === null) return

        const block = this.blocks[this.selectedBlockIndex]
        const points = [...block.points]

        // Actualizar el punto movido
        points[vertexIndex * 2] = circle.x()
        points[vertexIndex * 2 + 1] = circle.y()

        // Si es el primer punto, actualizar tambien el ultimo (cierre del poligono)
        if (vertexIndex === 0) {
          points[points.length - 2] = circle.x()
          points[points.length - 1] = circle.y()
        }

        // Actualizar reactivamente con $set
        this.$set(this.blocks[this.selectedBlockIndex], 'points', points)
      },

      _DeselectBlock() {
        if (this.selectedBlockIndex === null) return

        // Restaurar estilo original del bloque
        const block = this.blocks[this.selectedBlockIndex]
        if (block) {
          this.$set(this.blocks[this.selectedBlockIndex], 'stroke', this._originalBlockStroke || 'black')
          this.$set(this.blocks[this.selectedBlockIndex], 'fill', this._originalBlockFill || 'rgba(236, 236, 236, 0.68)')
        }

        this.$emit('epc-block-editing', null)

        const vectorLayer = this.$refs.refVectors?.getNode()

        // Destruir circulos de edicion
        this.editVertexCircles.forEach(c => c.destroy())
        this.editVertexCircles = []
        this.selectedBlockIndex = null

        if (vectorLayer) {
          vectorLayer.batchDraw()
        }
      },

      _FindBlockAtPoint(point) {
        // Buscar bloque que contenga el punto (iterando de ultimo a primero para prioridad visual)
        for (let i = this.blocks.length - 1; i >= 0; i--) {
          const block = this.blocks[i]
          if (!block.points || block.points.length < 6) continue

          // Algoritmo ray-casting para punto dentro de poligono
          const pts = block.points
          const numVertices = (pts.length / 2) - 1 // ultimo punto es cierre
          let inside = false

          for (let j = 0, k = numVertices - 1; j < numVertices; k = j++) {
            const xi = pts[j * 2] + (block.x || 0)
            const yi = pts[j * 2 + 1] + (block.y || 0)
            const xk = pts[k * 2] + (block.x || 0)
            const yk = pts[k * 2 + 1] + (block.y || 0)

            if (((yi > point.y) !== (yk > point.y)) &&
                (point.x < (xk - xi) * (point.y - yi) / (yk - yi) + xi)) {
              inside = !inside
            }
          }

          if (inside) return i
        }

        return null
      },

      // ========== EDICION DE TEXTOS ==========

      _FindTxtAtPoint(point) {
        for (let i = this.txtBlocks.length - 1; i >= 0; i--) {
          const txt = this.txtBlocks[i]
          const x = txt.x || 0
          const y = txt.y || 0
          const fontSize = txt.fontSize || 16
          // Estimar ancho del texto basado en caracteres y fontSize
          const textWidth = txt.text ? txt.text.length * fontSize * 0.6 : 100
          const textHeight = fontSize * 1.4

          if (point.x >= x && point.x <= x + textWidth &&
              point.y >= y && point.y <= y + textHeight) {
            return i
          }
        }
        return null
      },

      _SelectTxt(txtIndex) {
        this._DeselectTxt()
        this._DeselectBlock()

        this.selectedTxtIndex = txtIndex
        const txt = this.txtBlocks[txtIndex]
        if (!txt) return

        const vectorLayer = this.$refs.refVectors.getNode()
        const zoomLevel = this.konvaViewer.GetZoomLavel() || 1

        // Crear nodo temporal draggable sobre la capa de vectores
        this.editTxtNode = new Konva.Text({
          name: 'editTxt',
          text: txt.text,
          x: txt.x || 0,
          y: txt.y || 0,
          width: txt.width || undefined,
          fontSize: txt.fontSize || 16,
          fontStyle: txt.fontStyle || 'normal',
          fill: '#2980b9',
          rotation: txt.rotation || 0,
          draggable: true,
          hitStrokeWidth: 10,
        })

        // Transformer para rotacion y redimension
        this.editTxtTransformer = new Konva.Transformer({
          nodes: [this.editTxtNode],
          enabledAnchors: ['middle-left', 'middle-right'],
          rotateEnabled: true,
          rotateAnchorOffset: 20 / zoomLevel,
          anchorSize: 8 / zoomLevel,
          anchorStroke: '#2980b9',
          anchorFill: 'white',
          anchorCornerRadius: 2 / zoomLevel,
          borderStroke: '#2980b9',
          borderStrokeWidth: Math.max(0.3, 1 / zoomLevel),
          borderDash: [4 / zoomLevel, 2 / zoomLevel],
          boundBoxFunc: function (oldBox, newBox) {
            newBox.width = Math.max(20, newBox.width)
            return newBox
          },
        })

        // Al transformar, normalizar escala a ancho
        this.editTxtNode.on('transform', () => {
          this.editTxtNode.setAttrs({
            width: Math.max(20, this.editTxtNode.width() * this.editTxtNode.scaleX()),
            scaleX: 1,
            scaleY: 1,
          })
        })

        this.editTxtNode.on('transformend dragend', () => {
          this._SyncTxtToData()
        })

        this.editTxtNode.on('mouseover', () => {
          this._SetCursor('move')
        })

        this.editTxtNode.on('mouseout', () => {
          this._SetCursor('default')
        })

        // Ocultar el texto original de la capa refBlocks
        this.$set(this.txtBlocks[txtIndex], 'fill', 'transparent')

        vectorLayer.add(this.editTxtNode)
        vectorLayer.add(this.editTxtTransformer)
        vectorLayer.batchDraw()

        // Emitir datos al padre para controles de toolbar
        this.$emit('epc-txt-editing', {
          fontSize: txt.fontSize || 16,
          fontStyle: txt.fontStyle || 'normal',
        })
      },

      _SyncTxtToData() {
        if (this.selectedTxtIndex === null || !this.editTxtNode) return
        const idx = this.selectedTxtIndex
        this.$set(this.txtBlocks[idx], 'x', this.editTxtNode.x())
        this.$set(this.txtBlocks[idx], 'y', this.editTxtNode.y())
        this.$set(this.txtBlocks[idx], 'width', this.editTxtNode.width())
        this.$set(this.txtBlocks[idx], 'rotation', this.editTxtNode.rotation())
        this.$set(this.txtBlocks[idx], 'fontSize', this.editTxtNode.fontSize())
        this.$set(this.txtBlocks[idx], 'fontStyle', this.editTxtNode.fontStyle())
      },

      // Metodo publico: el padre llama para actualizar fontSize
      UpdateSelectedTxtFontSize(size) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        this.editTxtNode.fontSize(size)
        this.editTxtTransformer.forceUpdate()
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      // Metodo publico: el padre llama para toggle bold
      UpdateSelectedTxtBold(bold) {
        if (!this.editTxtNode || this.selectedTxtIndex === null) return
        this.editTxtNode.fontStyle(bold ? 'bold' : 'normal')
        this.editTxtTransformer.forceUpdate()
        this.$refs.refVectors.getNode().batchDraw()
        this._SyncTxtToData()
      },

      _DeselectTxt() {
        if (this.selectedTxtIndex === null) return

        // Sincronizar datos finales
        this._SyncTxtToData()

        // Restaurar color del texto original
        if (this.txtBlocks[this.selectedTxtIndex]) {
          this.$set(this.txtBlocks[this.selectedTxtIndex], 'fill', '#333')
        }

        const vectorLayer = this.$refs.refVectors?.getNode()
        if (vectorLayer) {
          if (this.editTxtTransformer) {
            this.editTxtTransformer.destroy()
            this.editTxtTransformer = null
          }
          if (this.editTxtNode) {
            this.editTxtNode.destroy()
            this.editTxtNode = null
          }
          vectorLayer.batchDraw()
        }

        this.selectedTxtIndex = null
        this.$emit('epc-txt-editing', null)
      },

      handleWheel(e) {
        // stop default scrolling
        // e.evt.preventDefault();
        // this.konvaViewer.ZoomStagePoiter(e, 1.2) //1.01

        // this._Screenshot();
      },

      _InsertTextField(position) {
        const vectorLayer = this.$refs.refVectors.getNode()
        const zoomLevel = this.konvaViewer.GetZoomLavel() || 1
        const fontSize = 16 / zoomLevel

        const txt = new Konva.Text({
          text: '',
          x: position.x,
          y: position.y,
          fontSize: fontSize,
          fill: '#333',
          draggable: true,
          width: 200 / zoomLevel,
        })

        const tr = new Konva.Transformer({
          node: txt,
          enabledAnchors: ['middle-left', 'middle-right'],
          boundBoxFunc: function (oldBox, newBox) {
            newBox.width = Math.max(30, newBox.width)
            return newBox
          },
        })

        txt.on('transform', function () {
          txt.setAttrs({
            width: txt.width() * txt.scaleX(),
            scaleX: 1,
          })
        })

        vectorLayer.add(txt)
        vectorLayer.add(tr)
        vectorLayer.batchDraw()

        // Abrir textarea inmediatamente para escribir
        this._OpenTextEditor(txt, tr)

        this.$emit('epc-viewer-design-selected-tool', null)
      },

      _OpenTextEditor(txtNode, transformer) {
        txtNode.hide()
        if (transformer) transformer.hide()

        const stage = this.$refs.stage.getNode()
        const container = this.$refs.canvasContainer
        const textPosition = txtNode.absolutePosition()
        const stageRect = stage.container().getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()

        // Posicion relativa al contenedor del canvas
        const areaPosition = {
          x: stageRect.left - containerRect.left + textPosition.x,
          y: stageRect.top - containerRect.top + textPosition.y,
        }

        const scale = txtNode.getAbsoluteScale().x

        const textarea = document.createElement('textarea')
        container.appendChild(textarea)

        textarea.value = txtNode.text()
        textarea.style.position = 'absolute'
        textarea.style.top = areaPosition.y + 'px'
        textarea.style.left = areaPosition.x + 'px'
        textarea.style.width = (txtNode.width() * scale) + 'px'
        textarea.style.fontSize = (txtNode.fontSize() * scale) + 'px'
        textarea.style.border = '1px dashed #2980b9'
        textarea.style.padding = '2px'
        textarea.style.margin = '0px'
        textarea.style.overflow = 'hidden'
        textarea.style.background = 'rgba(255,255,255,0.9)'
        textarea.style.outline = 'none'
        textarea.style.resize = 'none'
        textarea.style.lineHeight = String(txtNode.lineHeight())
        textarea.style.fontFamily = txtNode.fontFamily()
        textarea.style.transformOrigin = 'left top'
        textarea.style.textAlign = txtNode.align()
        textarea.style.color = txtNode.fill()
        textarea.style.zIndex = '1000'
        textarea.style.minHeight = '30px'
        textarea.style.height = 'auto'
        textarea.style.height = Math.max(30, textarea.scrollHeight + 3) + 'px'

        textarea.focus()

        const self = this
        let saved = false

        const saveAndClose = (saveText) => {
          if (saved) return
          saved = true

          textarea.removeEventListener('keydown', handleKeydown)
          window.removeEventListener('mousedown', handleOutsideClick)

          if (saveText && textarea.value.trim()) {
            // Guardar en txtBlocks para persistir
            self.txtBlockIdCounter++
            self.txtBlocks.push({
              id: self.txtBlockIdCounter,
              name: 'txtblock_' + self.txtBlockIdCounter,
              text: textarea.value,
              x: txtNode.x(),
              y: txtNode.y(),
              fontSize: txtNode.fontSize(),
              fontStyle: 'bold',
              fill: '#333',
            })
          }

          // Limpiar nodo temporal y textarea
          txtNode.destroy()
          if (transformer) transformer.destroy()
          if (textarea.parentNode) textarea.parentNode.removeChild(textarea)

          const vectorLayer = self.$refs.refVectors?.getNode()
          if (vectorLayer) vectorLayer.batchDraw()
        }

        const handleKeydown = (e) => {
          // Enter (sin Shift) confirma
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            saveAndClose(true)
            return
          }
          // Escape cancela
          if (e.key === 'Escape') {
            e.preventDefault()
            saveAndClose(false)
            return
          }
          // Auto-resize altura
          textarea.style.height = 'auto'
          textarea.style.height = Math.max(30, textarea.scrollHeight + 3) + 'px'
        }

        const handleOutsideClick = (e) => {
          if (e.target !== textarea) {
            saveAndClose(true)
          }
        }

        textarea.addEventListener('keydown', handleKeydown)
        // Delay para evitar que el click que abrio el editor lo cierre
        setTimeout(() => {
          window.addEventListener('mousedown', handleOutsideClick)
        }, 100)
      },

      handleContextMenu(e) {
        // prevent default behavior
        // console.log('handleContextMenu: ', e)
        // e.evt.preventDefault();
        // e.evt.stopPropagation()
        // const stage = this.$refs.stage.getNode();

        // if (e.target === stage) {
        //   // if we are on empty place of the stage we will do nothing
        //   return;
        // }
        // let currentShape = e.target;
        // console.log('handleContextMenu: ', currentShape)
        // show menu
        // menuNode.style.display = 'initial';
        // var containerRect = stage.container().getBoundingClientRect();
        // menuNode.style.top =
        //   containerRect.top + stage.getPointerPosition().y + 4 + 'px';
        // menuNode.style.left =
        //   containerRect.left + stage.getPointerPosition().x + 4 + 'px';
      },

      async _Screenshot() {
        return new Promise((resolve, reject) => {
          // let timeOut = null;
          // const l = ()=>{
          //     timeOut && window.clearTimeout(timeOut);
          //     try {
          //       console.log('screenshot')\
              this.$emit('epc-screenshot', this.konvaViewer.Screenshot());
              resolve()
          //       timeOut = window.setTimeout(l, 1e3)
          //     } catch (e) {
          //       console.log(e)
          //     }
          // };
          // l()
        })
      },

      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

      ZoomIn() {
        this.konvaViewer.ZoomStage(1.2)
      },

      ZoomOut() {
        this.konvaViewer.ZoomStage(0.8)
      },

      FitToScreen() {

        return new Promise((resolve, reject) => {

          this.konvaViewer.FitToScreen()
            .then(result => {
              resolve();//this._Screenshot()
            })

        })
      },

      // Función para manejar el evento de redimensionamiento
      handleResize() {
        this.konvaViewer.Resize()
      },

      _AllowedAction(action) {
        if (Object.keys(this.canActionsPictogram).length === 0)
          return false;

        return this.canActionsPictogram[action] === 'undefined' ? false : this.canActionsPictogram[action]
      },

      _GetLayerOrder() {
        const stage = this.$refs.stage.getStage();
        return stage.getChildren().map(layer => layer.getAttr('id'));
      },







    handleDragover(e) {
      e.preventDefault(); // !important
    },

    _FindGroupAtPoint(mousePos) {
      const layer = this.$refs.layer.getNode()
      const groups = layer.find('Group')
      for (let i = groups.length - 1; i >= 0; i--) {
        const group = groups[i]
        const box = group.getClientRect()
        if (this.isPointInRect(mousePos, box)) {
          return group.id()
        }
      }
      return null
    },

    _SetCursor(type) {
      const container = this.stage.container()
      container.style.cursor = type
    },

    handleMouseUp(e) {
      this._isMouseDown = false
      if (this._isPanMode) {
        this._SetCursor('grab')
      }
      if (!this.designMode || this.showAreas || !this.selectedGroupId) return

      // Al soltar el botón, cambiar cursor a grab si está sobre el grupo seleccionado
      const mousePos = this.stage.getPointerPosition()
      if (mousePos) {
        const foundGroupId = this._FindGroupAtPoint(mousePos)
        if (foundGroupId === this.selectedGroupId) {
          this._SetCursor('grab')
        } else {
          this._SetCursor('default')
        }
      }
    },

    handleMouseOver(e) {
      if (this._isPanMode) return
      if (!this.designMode) return

      // Si esta dibujando, delegar al preview de dibujo
      if (this.isDrawing) {
        this._SetCursor('crosshair')
        this.handleDrawingMouseMove(e)
        return
      }

      // Si la herramienta de texto esta activa, mostrar cursor text
      if (this.selectedTool === 'pencil') {
        this._SetCursor('text')
        return
      }

      // Cuando showAreas esta activo, no interactuar con grupos
      if (this.showAreas) return

      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return

      // Durante drag con botón pulsado, mantener grabbing
      if (this.isDragging && this._isMouseDown) {
        this._SetCursor('grabbing')
        return
      }

      const foundGroupId = this._FindGroupAtPoint(mousePos)

      // Cursor según contexto
      if (this.selectedGroupId && foundGroupId === this.selectedGroupId) {
        this._SetCursor('grab')
      } else if (foundGroupId) {
        this._SetCursor('pointer')
      } else {
        this._SetCursor('default')
      }

      // Si el hover no cambió, no hacer nada más
      if (foundGroupId === this.hoveredGroupId) return

      // Limpiar hover anterior
      this._ClearHighlight('hover')
      this.hoveredGroupId = foundGroupId

      if (this.hoveredGroupId && this.hoveredGroupId !== this.selectedGroupId) {
        const hoveredNode = this.stage.findOne(`#${this.hoveredGroupId}`)
        if (hoveredNode) {
          this._ApplyHighlight(hoveredNode, 'hover')
        }
      }

      this.$refs.layer.getNode().batchDraw()
    },

    handleMouseDown(e) {
      if (this._isPanMode) {
        this._SetCursor('grabbing')
      }
      if (!this.designMode || this.isDrawing || this.showAreas) return
      this._isMouseDown = true

      const mousePos = this.stage.getPointerPosition()
      if (!mousePos) return

      const clickedGroupId = this._FindGroupAtPoint(mousePos)

      // Mousedown en vacío o en otro grupo → deseleccionar el actual
      if (this.selectedGroupId && clickedGroupId !== this.selectedGroupId) {
        this._DeselectGroup()
        this.$refs.layer.getNode().batchDraw()
        this._ignoreClick = true // Ignorar el click que viene después
        return
      }

      // Mousedown en vacío sin selección → ignorar
      if (!clickedGroupId) return

      this._SetCursor('grabbing')

      // Si es el mismo grupo ya seleccionado, reactivar drag con startDrag
      if (this.selectedGroupId === clickedGroupId) {
        const groupNode = this.stage.findOne(`#${this.selectedGroupId}`)
        if (groupNode) {
          groupNode.startDrag()
          this.isDragging = true
          this._hasDragged = false
          this._ignoreClick = true
        }
        return
      }

      const layer = this.$refs.layer.getNode()
      const groupNode = this.stage.findOne(`#${clickedGroupId}`)

      // Seleccionar nuevo grupo
      this._ClearHighlight('hover')
      this._ClearHighlight('selected')
      this.selectedGroupId = clickedGroupId
      this.hoveredGroupId = null

      this._ApplyHighlight(groupNode, 'selected')

      groupNode.draggable(true)
      groupNode.moveToTop()
      groupNode.moveTo(layer)

      this.isDragging = true
      this._hasDragged = false
      this._ignoreClick = true

      // Escuchar dragmove para saber si realmente se movió
      groupNode.off('dragmove.select')
      groupNode.on('dragmove.select', () => {
        this._hasDragged = true
      })

      layer.batchDraw()
    },

    handleClick(e) {
      if (!this.designMode) return

      // Si esta dibujando, delegar al click de dibujo
      if (this.isDrawing) {
        this.handleDrawingClick(e)
        return
      }

      // Si la herramienta de texto esta activa, insertar texto en la posicion del click
      if (this.selectedTool === 'pencil') {
        const point = this._GetMousePointTransformed()
        if (point) {
          this._InsertTextField(point)
        }
        return
      }

      // Cuando showAreas esta activo, solo interactuar con bloques y textos (no con grupos)
      if (this.showAreas) {
        const point = this._GetMousePointTransformed()
        if (point) {
          // Primero verificar click en texto
          const txtIndex = this._FindTxtAtPoint(point)
          if (txtIndex !== null) {
            if (this.selectedTxtIndex === txtIndex) {
              this._DeselectTxt()
            } else {
              this._SelectTxt(txtIndex)
            }
            return
          }

          // Luego verificar click en bloque
          const blockIndex = this._FindBlockAtPoint(point)
          if (blockIndex !== null) {
            if (this.selectedBlockIndex === blockIndex) {
              this._DeselectBlock()
            } else {
              this._SelectBlock(blockIndex)
            }
          } else {
            // Click fuera de bloques y textos → deseleccionar todo
            this._DeselectBlock()
            this._DeselectTxt()
          }
        }
        return
      }

      // Ignorar el click que viene justo después de un mousedown que seleccionó
      if (this._ignoreClick) {
        this._ignoreClick = false

        // Si se movió durante el drag → soltar, mantener seleccionado
        if (this._hasDragged) {
          const node = this.stage.findOne(`#${this.selectedGroupId}`)
          if (node) {
            node.draggable(false)
            node.off('dragmove.select')
          }
          this.isDragging = false

          this._ClearHighlight('selected')
          if (node) {
            this._ApplyHighlight(node, 'selected')
          }
          this.$refs.layer.getNode().batchDraw()
        }
        return
      }

      // Click con grupo seleccionado (sin drag activo) → deseleccionar
      if (this.selectedGroupId) {
        this._DeselectGroup()
        this.$refs.layer.getNode().batchDraw()
        return
      }
    },

    _emitSelectedCount() {
      let count = 0
      if (this.selectedGroupId) count++
      if (this.selectedBlockIndex !== null) count++
      if (this.selectedTxtIndex !== null) count++
      this.$emit('epc-selected-count', count)
    },

    _DeselectGroup() {
      if (this.selectedGroupId) {
        const node = this.stage.findOne(`#${this.selectedGroupId}`)
        if (node) {
          node.stopDrag()
          node.draggable(false)
          node.off('dragmove.select')
        }
      }

      this._ClearHighlight('selected')
      this._ClearHighlight('hover')
      this._SetCursor('default')
      this.selectedGroupId = null
      this.hoveredGroupId = null
      this.isDragging = false
      this._hasDragged = false
      this._ignoreClick = false
      this._isMouseDown = false

      // Deseleccionar bloque y texto editado si hay uno
      this._DeselectBlock()
      this._DeselectTxt()
    },

    handleKeyDown(e) {
      if (!this.designMode) return

      // Si esta dibujando, delegar al keydown de dibujo
      if (this.isDrawing) {
        this.handleDrawingKeyDown(e)
        return
      }

      if (!this.selectedGroupId) return

      const arrowKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']
      if (!arrowKeys.includes(e.key)) return

      e.preventDefault()

      // Si está en drag con mouse, detenerlo
      if (this.isDragging) {
        const dragNode = this.stage.findOne(`#${this.selectedGroupId}`)
        if (dragNode) {
          dragNode.stopDrag()
          dragNode.draggable(false)
          dragNode.off('dragmove.select')
        }
        this.isDragging = false
      }

      const node = this.stage.findOne(`#${this.selectedGroupId}`)
      if (!node) return

      // Shift = 10px, normal = 1px
      const step = e.shiftKey ? 10 : 1

      switch (e.key) {
        case 'ArrowUp':    node.y(node.y() - step); break
        case 'ArrowDown':  node.y(node.y() + step); break
        case 'ArrowLeft':  node.x(node.x() - step); break
        case 'ArrowRight': node.x(node.x() + step); break
      }

      // Actualizar highlight a la nueva posición
      this._ClearHighlight('selected')
      this._ApplyHighlight(node, 'selected')

      this.$refs.layer.getNode().batchDraw()
    },

    _ApplyHighlight(group, type = 'hover') {
      const box = group.getClientRect({ relativeTo: group })
      const padding = 4

      const styles = {
        hover: {
          fill: 'rgba(52, 152, 219, 0.08)',
          stroke: 'rgba(52, 152, 219, 0.4)',
          strokeWidth: 1,
        },
        selected: {
          fill: 'rgba(52, 152, 219, 0.15)',
          stroke: 'rgba(52, 152, 219, 0.8)',
          strokeWidth: 1.5,
        }
      }

      const style = styles[type]

      const highlight = new Konva.Rect({
        name: 'highlight_' + type,
        x: box.x - padding,
        y: box.y - padding,
        width: box.width + padding * 2,
        height: box.height + padding * 2,
        fill: style.fill,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
        cornerRadius: 3,
        listening: false,
      })

      group.add(highlight)
      highlight.moveToBottom()
    },

    _ClearHighlight(type = null) {
      const layer = this.$refs.layer?.getNode()
      if (!layer) return

      if (type) {
        layer.find('.highlight_' + type).forEach(node => node.destroy())
      } else {
        layer.find('.highlight_hover').forEach(node => node.destroy())
        layer.find('.highlight_selected').forEach(node => node.destroy())
      }
    },

    isPointInRect(point, rect) {
      return point.x >= rect.x && point.x <= rect.x + rect.width &&
              point.y >= rect.y && point.y <= rect.y + rect.height;
    },

    handleClickOld(e) {
      if (! this.designMode)
        return

      // const stage = this.$refs.stage.getNode();
      // console.log(' e.target.getParent().className: ',  e.target.getParent().getType())
      // console.log(' e.target.getParent().className: ',  e.target.getParent().width())
      // console.log(' e.target.getParent().className: ',  e.target.getParent().height())

      // clicked on stage - clear selection
      // if (e.target === e.target.getStage()) {
      if (e.target === this.stage) {
        // this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      const node = e.target.findAncestor('.groupPictogram', true);
      // console.log('node: ', node)

      // var clickedGroup = e.target.findAncestor('Group');
      //descomentar esto luego
      // if (node) {
      //   // transformer.nodes([clickedGroup]);
      //   this.updateTransformer(node);
      //   // layer.draw();
      // }

      // find clicked rect by its name
      // const name = e.target.name();
      // console.log( name )
      // const rect = this.rectangles.find((r) => r.name === name);
      // if (rect) {
      //   this.selectedShapeName = name;
      // } else {
      //   this.selectedShapeName = '';
      // }
      // this.updateTransformer(node);
    },

    updateTransformer(node=null) {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      // const selectedNode = stage.findOne('.' + selectedShapeName);
      // // do nothing if selected node is already attached
      // if (selectedNode === transformerNode.node()) {
      //   return;
      // }

      if (node === transformerNode.node()) {
        return;
      }


      // if (selectedNode) {
      if (node) {
        // attach to another node
        // transformerNode.nodes([selectedNode]);
        transformerNode.nodes([node]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
    },

    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
    //   const rect = this.rectangles.find(
    //     (r) => r.name === this.selectedShapeName
    //   );
    //   // update the state
    //   rect.x = e.target.x();
    //   rect.y = e.target.y();
    //   rect.rotation = e.target.rotation();
    //   rect.scaleX = e.target.scaleX();
    //   rect.scaleY = e.target.scaleY();

    //   // change fill
    //   rect.fill = Konva.Util.getRandomColor();
    },

    handleDragStart() {
      this.isDragging = true;
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    _GetImageConfig(obj) {
      let config = {
        neme: 'pic_' + obj.id,
        id: 'pic_' + obj.id
      }

      this.imageConfig.name = 'pic_' + obj.id
      this.imageConfig.id = 'pic_' + obj.id // asignamos igual para buscar por #id
      config.x = obj.x ? obj.x : this.imageConfig.x
      config.y = obj.y ? obj.y : this.imageConfig.y
      config.width = this.imageConfig.width
      config.height = this.imageConfig.height

      if (obj.rotation) {
        config.rotation = obj.rotation
      }
      return config
    },
  },

    created() {
      this.uppy = new Uppy({
        debug: process.env.NODE_ENV === 'development', // activamos debug para development
        autoProceed: false,
        allowMultipleUploads: true,
      })
      .use(AwsS3, {
        shouldUseMultipart: true,
        limit: 3,
        companionUrl: '/api/v2/',
        endpoint: '/api/v2/',
        headers: {
          'Authorization': "Bearer " + store.getters["auth/token"]
        }
      })
      // .on('upload-success', (file, response) => { this.onUploadSuccess(file, response) } )
      .on('upload-success', (file, response) => { // callback deveulto cuando el file ha sido subido correctamente
        console.log('%cEPC-TACKER: '+ '%c file ' + file.data.name + ' subido correctamente', 'background: #5577BB; color: #fff', 'color: #000')
      })
      .on('upload-progress', (file, progesss) => { // callback devuelto con el progreso de subido del archivo
        this.uploadPercentage = parseInt(
          Math.round((progesss.bytesUploaded * 100) / progesss.bytesTotal)
        );
      })
      .on('upload-error', (file, error, response) => { // callback devuelto si ha ocurrido algun error en la subida
        console.error('%cEPC-TACKER: '+ '%c a ocurrido un error al subir el archivo ' + file.data.name, 'background: #5577BB; color: #fff', 'color: #000', error)
      })

    },

    mounted() {
      this.stage = this.$refs.stage.getStage()
      this.konvaViewer = new KonvaViewer(this.$refs.canvasContainer, this.stage)
      this.Load()

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('keydown', this.handleKeyDown);

      this.$emit('epc-mounted')
    },

    beforeDestroy() {
      // Deseleccionar grupo activo antes de destruir
      this._DeselectGroup()

      // Limpiar event listeners
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('keydown', this.handleKeyDown)

      // Cerrar Uppy para liberar recursos
      if (this.uppy) {
        this.uppy.destroy()
        this.uppy = null
      }

      // Destruir el viewer de Konva
      if (this.konvaViewer) {
        this.konvaViewer.Destroy()
        this.konvaViewer = null
      }
    }
}
</script>

<style scoped>

.canvasContainer {
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 100px;
    min-height: 100px;

    background-color: #fefefe;
    .progress {
        position: absolute;
        z-index: 20;
        width: 90%;
        margin: 20px 5%;

        .progressText {
            margin: 10px 20px;
            font-size: 14px;
            color: #262d33;
            text-align: center;
        }
    }

    .error {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 20;
        padding: 30px;

        img {
            width: 24px;
            height: 24px;
            vertical-align: middle;
            margin: 4px;
        }
    }
}

</style>
